import { HttpClient as BaseClient } from 'module/api/http-client';
import { axiosInstance } from './axios';

abstract class HttpClient extends BaseClient {
  public constructor() {
    super(axiosInstance);
  }
}

export { HttpClient };
